import { render, staticRenderFns } from "./payoneer.vue?vue&type=template&id=8911c874&scoped=true&"
import script from "./payoneer.vue?vue&type=script&lang=tsx&"
export * from "./payoneer.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8911c874",
  null
  
)

export default component.exports